/* eslint-disable no-shadow */
import React, { FC, useEffect, useState } from 'react';
import {
  ESort,
  InitialChosen,
  InitialFilters,
  InitialSortOption,
  TAppState,
  TChosen,
  TFilters,
  InitialSettings,
  TSettings,
  TDragedToy,
  InitialGarland,
  TGarland,
} from './app-type';

const AppContext = React.createContext<TAppState>({
  filters: InitialFilters,
  setFilters: () => {},
  sorts: InitialSortOption,
  setSortOptions: () => {},
  chosens: InitialChosen,
  setChosenToy: () => {},
  settings: InitialSettings,
  setSettings: () => {},
  toysOnTree: [],
  setToysOnTree: () => {},
  garlandSettings: InitialGarland,
  setGarland: () => {},
});

const AppProvider: FC = ({ children }) => {
  const [filters, setFilters] = useState<TFilters>(InitialFilters);
  const [sorts, setSortOptions] = useState<ESort>(InitialSortOption);
  const [chosens, setChosenToy] = useState<TChosen>(InitialChosen);
  const [settings, setSettings] = useState<TSettings>(InitialSettings);
  const [toysOnTree, setToysOnTree] = useState<TDragedToy[]>([]);
  const [garlandSettings, setGarland] = useState<TGarland>(InitialGarland);

  useEffect(() => {
    const data = localStorage.getItem('chosens');
    if (data) setChosenToy(JSON.parse(data));
    const data2 = localStorage.getItem('sorts');
    if (data2) setSortOptions(JSON.parse(data2));
    const data3 = localStorage.getItem('filters');
    if (data3) setFilters(JSON.parse(data3));
    const data4 = localStorage.getItem('settings');
    if (data4) setSettings(JSON.parse(data4));
  }, []);

  useEffect(() => {
    localStorage.setItem('chosens', JSON.stringify(chosens));
  }, [chosens]);
  useEffect(() => {
    localStorage.setItem('sorts', JSON.stringify(sorts));
  }, [sorts]);
  useEffect(() => {
    localStorage.setItem('filters', JSON.stringify(filters));
  }, [filters]);
  useEffect(() => {
    localStorage.setItem('settings', JSON.stringify(settings));
  }, [settings]);
  return (
    <AppContext.Provider
      value={{
        filters,
        setFilters,
        sorts,
        setSortOptions,
        chosens,
        setChosenToy,
        settings,
        setSettings,
        toysOnTree,
        setToysOnTree,
        garlandSettings,
        setGarland,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppProvider };
